import { IGroup } from './group';
import { IRole } from './role';

export interface IUser {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    username: string,
    centerId: number,
    centerAlias: string,
    groupId: number,
    courierVendor: number,
    isMicrositeCoach: boolean,
    contactId: number,
    donorConnectCaseLoad: number,
    mobileNumber: string,
    isTwoFactorEnabled: boolean,
    twoFactorKeyDateTime: string,
    expirePasswordDateTime: string,
    courierName: string,
    sendTicketNotification: boolean,
    isLockedOut: boolean,
    isDeactivated: boolean,
    lastLoginAttemptIp: string,
    lastLoginAttemptCount: number,
    ipLoginFailureCount: number,
    lastVisit: string,
    canHardDelete: boolean,
    timeZone: number,
    group: IGroup,
    organTypeId: number
    organType: string,
    opoId: number,
    opoName: string,
    roles: IRole[]
    // positions: IListItem[]
}
